export const GET_CCL_TITLES = 'GET_CCL_TITLES ';
export const SET_CCL_TITLES = 'SET_CCL_TITLES';
export const ERROR_CCL_TITLES = 'ERROR_CCL_TITLES';
